import script from "./ToolsProvider.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolsProvider.vue?vue&type=script&setup=true&lang=js"

import "./ToolsProvider.vue?vue&type=style&index=0&id=5c649e74&lang=sass"

const __exports__ = script;

export default __exports__